// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonGroup_root__3NCyI","button":"ButtonGroup_button__2sPW6","horizontal":"ButtonGroup_horizontal__2OYKU","vertical":"ButtonGroup_vertical__3vNrM"};